module.exports = __webpack_public_path__ + "static/EnmTX_BosDarius_L_B_cl-ffdaca6555cbb952ea671365ef4effb0.gif";